// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".but_block[data-v-19af8663]{margin-bottom:10px}.right_client_info[data-v-19af8663]{background:#f5f5f5}", ""]);
// Exports
module.exports = exports;
